import { configureStore } from '@reduxjs/toolkit';
import { api } from '@/src/api/api';
import auctionsSlice from './auctionsSlice/auctionsSlice';
import createUserSlice from './userSlice/userSlice';
import createCustomerSlice, {
  customerState,
  nullCustomer,
} from './customerSlice/customerSlice';
import customerAuctionsSlice from './auctionsSlice/customerAuctionsSlice';

export default function customConfigureStore(
  userInfo: any,
  customerInfo: customerState
) {
  const customer = { ...customerInfo } as customerState;
  const userSlice = createUserSlice(userInfo);
  const customerSlice = createCustomerSlice(customer);

  const store = configureStore({
    reducer: {
      user: userSlice.reducer,
      customer: customerSlice.reducer,
      auctions: auctionsSlice,
      customerAuctions: customerAuctionsSlice,
      [api.reducerPath]: api.reducer,
    },
    middleware: (getDefaultMiddleware) =>
      getDefaultMiddleware().concat(api.middleware),
  });

  return store;
}

const store = customConfigureStore({ userId: 0 }, nullCustomer);
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
